<template>
  <div class="d-flex flex-column">
    <InvoiceHeader :invoice="job.invoice" @refresh-invoice="refreshInvoice" />
    <div v-if="job.invoice">
      <Invoice
        class="ssui-invoice"
        :invoice="job.invoice"
        :customizations="customizations"
        :equipment-types-enabled="equipmentTypesEnabled"
        :tenant-timezone="tenantTimezone"
        @edit-transaction-note-click="handleEditNoteClick"
        @edit-transaction-reference-id-click="handleEditReferenceIdClick"
        @equipment-request-click="toggleModal('captureModal')"
      />
      <EquipmentCaptureModal
        v-if="captureModal"
        :invoice="job.invoice"
        :address="job.address"
        :equipment="customerEquipment"
        @hide-modal="toggleModal('captureModal')"
        @refresh-invoice="refreshInvoice"
      />
      <EditTransactionNotesModal
        v-if="editNotesModal"
        :transaction="selectedTransaction"
        @hide-modal="clearNotesModal"
      />
      <TransactionReferenceIdModal
        v-if="editReferenceIdModal"
        :transaction="selectedTransaction"
        @hide-modal="clearReferenceIdModal"
      />
    </div>
    <div v-else class="no-invoice">
      <i class="fad fa-question-circle"></i>
      No Invoice Available
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import EquipmentCaptureModal from "@/Equipment/EquipmentCaptureModal.vue";
import InvoiceHeader from "@/Invoice/InvoiceHeader.vue";
import EditTransactionNotesModal from "@/Job/EditTransactionNotesModal.vue";
import TransactionReferenceIdModal from "@/Job/TransactionReferenceIdModal.vue";

export default {
  components: {
    TransactionReferenceIdModal,
    InvoiceHeader,
    EditTransactionNotesModal,
    EquipmentCaptureModal
  },
  data() {
    return {
      editNotesModal: false,
      editReferenceIdModal: false,
      selectedTransaction: null,
      captureModal: false
    };
  },
  computed: mapState({
    job: "job",
    customerEquipment: "customerEquipment",
    customizations: ({ tenantCustomizations, tenant }) => {
      if (!tenant || !tenantCustomizations) {
        return null;
      }
      return {
        ...tenantCustomizations,
        Tenant: { ...tenant }
      };
    },
    equipmentTypesEnabled({ tenant }) {
      if (!tenant) return false;
      return tenant.feature_flags.equipment_types;
    },
    tenantTimezone({ tenant }) {
      if (!tenant) return "";
      return tenant.timezone;
    }
  }),
  created() {
    EventBus.$on("refresh-invoice", this.refreshInvoice);
  },
  beforeUnmount() {
    EventBus.$off("refresh-invoice", this.refreshInvoice);
  },
  methods: {
    ...mapActions(["fetchJob"]),
    toggleModal(modal) {
      this[modal] = !this[modal];
    },
    handleEditNoteClick(transaction) {
      this.selectedTransaction = transaction;
      this.editNotesModal = true;
    },
    handleEditReferenceIdClick(transaction) {
      this.selectedTransaction = transaction;
      this.editReferenceIdModal = true;
    },
    clearNotesModal() {
      this.editNotesModal = false;
      this.selectedTransaction = null;
    },
    clearReferenceIdModal() {
      this.editReferenceIdModal = false;
      this.selectedTransaction = null;
    },
    refreshInvoice() {
      this.fetchJob({ jobId: this.job.id });
    }
  }
};
</script>

<style lang="scss" scoped>
.no-invoice {
  color: var(--gray);
  font-size: 1.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  i {
    font-size: 4rem;
    margin-bottom: 10px;
  }
}

:deep(.invoice-body) {
  .table {
    margin-bottom: 0;
    border-radius: 4px 4px 0 0;
  }
  .totals {
    box-shadow: var(--box-shadow);
  }
}

:deep(.table td) {
  border-top: none; // Removes bootstrap default border display
  vertical-align: baseline !important; // Removes bootstrap default column align
}
</style>
